import { CardShell } from './CardShell';

export type TimelineItem = {
  id?: string; ID?: string;
  action?: string; Action?: string;
  from_status?: string; FromStatus?: string;
  to_status?: string; ToStatus?: string;
  operator_name?: string; OperatorName?: string;
  operator_avatar?: string; OperatorAvatar?: string;
  comment?: string; Comment?: string;
  created_at?: string; CreatedAt?: string;
};

const pick = (d: TimelineItem, k: string): string => {
  const v = (d as Record<string, unknown>)[k];
  return typeof v === 'string' ? v : '';
};

export function TimelineCard({ items, source = 'ai' }: { items: TimelineItem[]; source?: 'ai' | 'page' }) {
  const list = Array.isArray(items) ? items : [];
  return (
    <CardShell title={`时间线（${list.length} 条）`} source={source}>
      <div style={{ maxHeight: 260, overflowY: 'auto' }}>
        {list.map((it, i) => {
          const name = pick(it, 'operator_name') || pick(it, 'OperatorName') || '系统';
          const avatar = pick(it, 'operator_avatar') || pick(it, 'OperatorAvatar');
          const from = pick(it, 'from_status') || pick(it, 'FromStatus');
          const to = pick(it, 'to_status') || pick(it, 'ToStatus');
          const action = pick(it, 'action') || pick(it, 'Action') || (from && to ? `${from} → ${to}` : '流转');
          const comment = pick(it, 'comment') || pick(it, 'Comment');
          const raw = pick(it, 'created_at') || pick(it, 'CreatedAt');
          const t = raw ? new Date(raw) : null;
          const timeText = t && !isNaN(t.getTime())
            ? t.toLocaleString('zh-CN', { hour12: false }) : (raw || '');
          return (
            <div key={pick(it, 'id') || pick(it, 'ID') || i} style={{ display: 'flex', gap: 8, padding: '6px 0', borderBottom: '1px dashed #f0f0f0' }}>
              {avatar
                ? <img src={avatar} alt="" style={{ width: 24, height: 24, borderRadius: '50%' }} />
                : <div style={{ width: 24, height: 24, borderRadius: '50%', background: '#e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, color: '#6b7280' }}>{name.slice(0, 1)}</div>}
              <div style={{ flex: 1, fontSize: 12 }}>
                <div><b>{name}</b> {action}</div>
                {comment && <div style={{ color: '#6b7280', marginTop: 2 }}>{comment}</div>}
                <div style={{ color: '#9ca3af', marginTop: 2, fontSize: 11 }}>{timeText}</div>
              </div>
            </div>
          );
        })}
        {list.length === 0 && <div style={{ color: '#9ca3af', fontSize: 12 }}>暂无记录</div>}
      </div>
    </CardShell>
  );
}
